// TabContext.js
import React, { createContext, useState } from 'react';

const TabContext = createContext();

export const TabProvider = ({ children }) => {
    const [currentTab, setCurrentTab] = useState('Home'); // Set default tab to 'Home'

    const handleTabChange = (tab) => {
        setCurrentTab(tab);
    };

    return (
        <TabContext.Provider value={{ currentTab, handleTabChange }}>
            {children}
        </TabContext.Provider>
    );
};

export default TabContext;
